class ModalAdminBackground {
  constructor (opts) {
    const that = this;

    this.opts = $.extend(
      {
        baseUrl: INKIVE.C.BASE_URL,
        staticUrl: INKIVE.C.STATIC_URL,

        text_name: 'Background name',
        text_readable_name: 'Readable name',
        text_tags: 'Tags',
        text_active: 'Is background active?',
        text_set: 'Priority',
        text_category: 'Category',
        text_name_tooltip:
          "<b>Name</b><br />Make sure that you insert right name. Don't use white-space and special characters except hypen(-) and undersocre(_)",
        text_tags_tooltip:
          "<b>Tag - Sub filter</b><br />Seperate using comma(,) and don't use any special characters. ex) Blue, Snack, Cookie",
        text_set_tooltip:
          '<b>Priority</b><br />0 is most important and the number getting biger than will get less importantance. 0 will be shown in first list.'
      },
      opts
    );

    this.$wrapper = $(
      this.opts.wrapper
        ? $.parseHTML(this.opts.wrapper)
        : $.parseHTML('<div class="tool-content"></div>')
    );

    this.data = null;

    loadData(function () {
      initTemplate();
      initData(that.data);
    });

    /** ** Private methods *********************************************************************************************/

    function initTemplate () {
      const html =
        '<div style="display: table; width:100%">' +
        // First col
        '<div style="display: table-cell; vertical-align: top;"><section>' +
        '<img src="' +
        INKIVE.C.THUMB_NOCOVER +
        '" style="border: 1px solid rgb(49, 61, 67);"/>' +
        '<div class="checkbox"><input style=" type="checkbox" name="isActive" value="1"/>' +
        '<label for="isActive">' +
        that.opts.text_active +
        '</label></div>' +
        '<label>' +
        that.opts.text_category +
        '</label>' +
        '<input type="text" name="categories" data-role="tagsinput" />' +
        '</section></div>' +
        // Second col
        '<div style="display: table-cell; vertical-align: top;">' +
        '<section><label for="name">' +
        that.opts.text_name +
        '</label><input type="text" name="name" class="form-control" data-popover="tooltip" data-original-title="' +
        that.opts.text_name_tooltip +
        '"/></section>' +
        '<section><label for="readable_name">' +
        that.opts.text_readable_name +
        '</label><input type="text" name="readable_name" class="form-control"/></section>' +
        '<label for="tags">' +
        that.opts.text_tags +
        '</label><div data-popover="tooltip" data-original-title="' +
        that.opts.text_tags_tooltip +
        '"><input type="text" name="tags" data-role="tagsinput"/></div>' +
        '<section><label for="set">' +
        that.opts.text_set +
        '</label><input type="text" name="set" data-role="tagsinput" data-popover="tooltip" data-original-title="' +
        that.opts.text_set_tooltip +
        '"/></section>' +
        '</div>' +
        '</div>';

      that.$wrapper.append($.parseHTML(html));

      that.$wrapper.find('[data-popover="tooltip"]').tooltip({
        placement: 'auto',
        html: true
      });

      that.$wrapper.trigger('contentChanged');
    }

    function initData (data) {
      // Thumb
      const $img = that.$wrapper.find('img');
      $img.hide();

      const url = data.url ? data.url.replace('-web', '-thumb') : null;
      INKIVE.Helpers.imageLoader(url, function (status, img) {
        const cover =
          status == INKIVE.C.Status.success ? url : INKIVE.C.THUMB_NOCOVER;

        $img.attr('src', cover).fadeIn('slow');
      });

      // Name
      const $name = that.$wrapper.find('[name="name"]');
      if (data.name) $name.val(data.name);
      $name.keyup(function (event) {
        const text = $(this).val();
        $(this).val(
          text
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9\-\_]/g, '')
        );
      });

      // Readable Name
      const $readable_name = that.$wrapper.find('[name="readable_name"]');
      if (data.readable_name) $readable_name.val(data.readable_name);

      // Set
      const $set = that.$wrapper.find('[name="set"]');
      if (data.set) $set.val(data.set);
      $set.keyup(function (event) {
        const text = $(this).val();
        $(this).val(text.trim().replace(/[^0-9]/g, ''));
      });

      // Category
      const $categories = that.$wrapper.find('[name="categories"]');
      const categories = INKIVE.Tool._cache.backgroundCategories;

      $categories.tagsinput({
        itemValue: function (item) {
          return item.id;
        },
        itemText: function (item) {
          return item.name;
        },
        typeahead: { source: categories }
      });

      if (data.category) {
        $.each(data.category.split(','), function (index, id) {
          const category = _.find(INKIVE.Tool._cache.backgroundCategories, {
            id
          });
          category && $categories.tagsinput('add', category);
        });
        that.$wrapper.trigger('contentChanged');
      }

      // Tags
      const $tags = that.$wrapper.find('[name="tags"]');
      $tags.tagsinput({ itemValue: 'id', itemText: 'name' });
      if (data.tag) {
        $.each(data.tag.split(','), function (index, tag) {
          $tags.tagsinput('add', { id: tag, name: tag });
        });
        that.$wrapper.trigger('contentChanged');
      }

      $tags.tagsinput('input').keyup(function (event) {
        const keycode = event.keyCode ? event.keyCode : event.which;
        let text = $(this).val();
        text = text.replace(/[^a-zA-Z0-9, ]/g, '');
        $(this).val(text);

        if (keycode == 13 || keycode == 188) {
          text = text.trim().replace(/,/g, '');
          $tags.tagsinput('add', { id: text, name: text });
          $tags.tagsinput('input').val('');
        }
      });

      $tags.tagsinput('input').change(function (event) {
        const text = $(this).val();
        $tags.tagsinput('add', { id: text, name: text });
        $tags.tagsinput('input').val('');
      });

      // Is active
      const checked = 'check';
      if (parseInt(data.active)) {
        that.$wrapper.find('[name=isActive]').attr('checked', checked);
      }
    }

    function loadData (callback) {
      callback = callback || $.noop;

      INKIVE.Modal.loader(that.$wrapper);

      if (that.opts.id) {
        INKIVE.Helpers.api(
          'search/background',
          'GET',
          { id: that.opts.id },
          function (r) {
            INKIVE.Modal.loaderClose(that.$wrapper);

            if (r.id) {
              that.data = r || {};
              callback();
            } else {
              that.$wrapper.append(
                'Error in loading background ID ' + that.opts.id
              );
            }
          }
        );
      } else if (that.opts.data) {
        INKIVE.Modal.loaderClose(that.$wrapper);

        that.data = that.opts.data;
        callback();
      } else {
        INKIVE.Modal.loaderClose(that.$wrapper);

        that.data = {};
        callback();
      }
    }
  }

  getFormHtml () {
    return this.$wrapper;
  }

  getData () {
    return this.data;
  }

  getFormData () {
    return {
      id: this.data.id,
      set: this.$wrapper.find('[name="set"]').val(),
      tag: this.$wrapper.find('[name="tags"]').val(),
      name: this.$wrapper.find('[name="name"]').val(),
      active: this.$wrapper.find('[name=isActive]').is(':checked') ? 1 : 0,
      category: this.$wrapper.find('[name="categories"]').val(),
      readable_name: this.$wrapper.find('[name="readable_name"]').val()
    };
  }

  saveForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const info = that.getFormData();

    INKIVE.Helpers.api(
      'management/backgroundinfo',
      'POST',
      {
        info
      },
      function (r) {
        if (r && r.status == 'success') {
          callback(true, $.extend(that.getData(), info, { id: r.id }));
        } else {
          INKIVE.Modal.alertMessage(
            '<b>Error - </b><i>Updating background info</i><br>'
          );
          callback(false);
        }
      }
    );
  }

  deleteForm (callback) {
    callback = callback || $.noop;
    const that = this;

    const info = that.getFormData();

    INKIVE.Helpers.api(
      'management/background',
      'DELETE',
      {
        id: info.id
      },
      function (r) {
        if (r && r.status == 'success') {
          callback(true);
        } else {
          INKIVE.Modal.alertMessage(
            '<b>Error - </b><i>Delete background</i><br>'
          );
          callback(false);
        }
      }
    );
  }
}

module.exports = ModalAdminBackground;
